import React, { useState } from 'react';
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Form,
  FormGroup,
  Input,
  Row,
  Col,
  FormFeedback,
  InputGroup,
  InputGroupAddon,
  InputGroupText,
  Label,
} from 'reactstrap';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { ADMIN_CHANGE_PASSWORD } from '../../../../utils/APIEndpoints';
import { authHeader } from '../../../../utils/functions/CoreFunctions';
import API from '../../../../redux/actions/API';
import Swal from 'sweetalert2';
import { getAlertToast } from '../../../../utils/functions/CustomFunctions';
import CustomLoader from '../../../common/CustomLoader';
import { useLocation } from 'react-router-dom';

function AdminPasswordControl(props) {
  const { email = '', data = {}, toggle } = props;
  const location = useLocation();
  const [initialValues, setintialValues] = useState({
    password: '',
    confirmPassword: '',
  });

  const validationSchema = Yup.object({
    password: Yup.string().required('Password is Required'),
    confirmPassword: Yup.string()
      .required('Confirm Password is Required')
      .oneOf([Yup.ref('password'), null], 'Passwords must match'),
  });

  const [isPasswordType, setPasswordInputType] = useState(true);
  const [btnLoading, setBtnLoading] = useState(false);

  const togglePasswordType = () => {
    setPasswordInputType(!isPasswordType);
  };

  //Formik
  const {
    handleSubmit,
    handleChange,
    values,
    errors,
    touched,
    setFieldTouched,
    setFieldValue,
    handleBlur,
  } = useFormik({
    initialValues,
    enableReinitialize: true,
    validationSchema,
    onSubmit: (values) => {
      changePassword(values);
    },
  });

  const changePassword = async (values) => {
    if (data.userId) {
      setBtnLoading(true);
      try {
        const config = {
          method: 'PUT',
          url: ADMIN_CHANGE_PASSWORD,
          headers: authHeader(),
          data: {
            userId: data.userId,
            password: values.password,
            hyperlink: window.location.origin,
          },
        };
        const response = await API(config);
        const { status, message } = response.data;
        if (status == 'Success') {
          Swal.fire(getAlertToast('success', message));
        }
      } catch (error) {
        if (error.response) {
          let { data } = error.response;
          Swal.fire(getAlertToast('error', data.message));
        }
      } finally {
        setBtnLoading(false);
        toggle();
      }
    } else {
      Swal.fire(getAlertToast('error', 'user not found'));
    }
  };
  // console.log('data', window.location.origin);
  return (
    <Form form="true" onSubmit={handleSubmit}>
      <ModalBody>
        <Col md={8}>
          <FormGroup>
            <Label for="email">Email</Label>
            <Input
              type="email"
              name="email"
              id="email"
              placeholder="Email"
              disabled
              value={email}
            />
          </FormGroup>
        </Col>
        <Col md={8}>
          <FormGroup>
            <Label for="examplePassword">New Password</Label>
            <InputGroup>
              <Input
                type={isPasswordType ? 'password' : 'text'}
                name="password"
                placeholder="Enter Password"
                invalid={errors.password && touched.password ? true : false}
                onChange={handleChange}
                values={values.password}
                onBlur={handleBlur}
              />
              <InputGroupAddon addonType="append">
                <InputGroupText
                  onClick={togglePasswordType}
                  style={{ cursor: 'pointer' }}
                >
                  {isPasswordType ? (
                    <i className="fas fa-eye-slash" />
                  ) : (
                    <i className="fas fa-eye" />
                  )}
                </InputGroupText>
              </InputGroupAddon>
              <FormFeedback>
                {errors.password && touched.password ? errors.password : null}
              </FormFeedback>
            </InputGroup>
          </FormGroup>
        </Col>
        <Col md={8}>
          <FormGroup>
            <Label for="examplePassword">Confirm Password</Label>
            <InputGroup>
              <Input
                type={isPasswordType ? 'password' : 'text'}
                name="confirmPassword"
                placeholder="Enter Password"
                invalid={
                  errors.confirmPassword && touched.confirmPassword
                    ? true
                    : false
                }
                onChange={handleChange}
                values={values.confirmPassword}
                onBlur={handleBlur}
              />
              <InputGroupAddon addonType="append">
                <InputGroupText
                  onClick={togglePasswordType}
                  style={{ cursor: 'pointer' }}
                >
                  {isPasswordType ? (
                    <i className="fas fa-eye-slash" />
                  ) : (
                    <i className="fas fa-eye" />
                  )}
                </InputGroupText>
              </InputGroupAddon>
              <FormFeedback>
                {errors.confirmPassword && touched.confirmPassword
                  ? errors.confirmPassword
                  : null}
              </FormFeedback>
            </InputGroup>
          </FormGroup>
        </Col>
      </ModalBody>
      <ModalFooter>
        <Button color="primary" type="submit">
          {btnLoading && <CustomLoader loading={btnLoading} />}
          Submit
        </Button>
        <Button color="secondary" onClick={toggle}>
          Cancel
        </Button>
      </ModalFooter>
    </Form>
  );
}

export default AdminPasswordControl;
